import { render, staticRenderFns } from "./class-info.vue?vue&type=template&id=2617a987&scoped=true"
import script from "./class-info.vue?vue&type=script&lang=js"
export * from "./class-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617a987",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2617a987')) {
      api.createRecord('2617a987', component.options)
    } else {
      api.reload('2617a987', component.options)
    }
    module.hot.accept("./class-info.vue?vue&type=template&id=2617a987&scoped=true", function () {
      api.rerender('2617a987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-info.vue"
export default component.exports